export default function() {
    this.loadCustomersTrips()
}
